export const PARTNER_CONFIG = {
  apiUrl: "https://wl.nebula.stg-cbus.com/api",
  localesUrl: "//d18icbgk5z9c1l.cloudfront.net/i18n",
  imagesUrl: "//d20xk4sxen1bs2.cloudfront.net",
  fantasyStatsUrl: 'https://cb-stats-feed.nebula.stg-cbus.com/api',
  websocketsUrl: 'ws-eu.pusher.com',
  websocketsKey: '73c617c8039669312058',
  websocketCluster: 'eu',
  enableSyndicates: true,
  enableFreeplay: true,
  allowCashOutNotifications: false,
  widgetImages: [{
    default: '/assets/images/widget/colossus/placeholder.jpg'
  }],
  micrositeType: ['FANTASY'],
  rulesDocs: {
    default: '2PACX-1vSxt5MIZGCEgdU52WBr-oxw1hu_5T6oUNwCPNRVMtCNSTIPIeeJqmD-l1ZyuZiUFhUR1urhU4qFYJ15',
    en: '2PACX-1vSxt5MIZGCEgdU52WBr-oxw1hu_5T6oUNwCPNRVMtCNSTIPIeeJqmD-l1ZyuZiUFhUR1urhU4qFYJ15'
  },
  faqDocs: {
    default: '2PACX-1vT86_aJKkwsRRkh6gXEi9FvMN_chR8M1C1dSUKjcgvQNbj23-AF7lFme6i3-sjbtb3YTlWELxWyq_3Z',
    en: '2PACX-1vT86_aJKkwsRRkh6gXEi9FvMN_chR8M1C1dSUKjcgvQNbj23-AF7lFme6i3-sjbtb3YTlWELxWyq_3Z',
  },
  usDateFormat: true,
  syndicatesEnabled: true,
  hideSyndicatesTab: false,
  fallbackSecureWSnonCB: true,
  /* imported from colossus & wallet */



  'templateServiceUrl': 'https://templates.colossusbets.com/?uuid=[UUID_CODE]&merchant=colossus',
  'enableVideoStreaming': true,
  'ravenUrl': 'https://0c14f07ea4c545beb5697a5cccb860a9@o113114.ingest.sentry.io/5389973',
  'ravenRelease': 'cb-mido@0.0.1',
  'ravenEnvironment': 'web',
  'videoStreamingSport': ['GREYHOUNDS'],
  'videoStreamUrl': 'https://v.sis.tv/StreamingService/api/v2/stream?',
  'merchant_code': 'MIDO',
  'streamUrl': 'https://wl.staging-colossusbets.com/streams',
  'scopes': ['locales', 'competitors', 'syndicates', 'wallet', 'sharing', 'us-version', 'merchant/mido'],
  'allowLogin': false,
  'allowRegister': false,
  'allowBalance': true,
  'crossSellStakeTier': 1,
  'enableSyndicatesLeaderboard': true,
  'freePlayStandaloneLogo': '/assets/images/standalone/colossus/racing-freeplay-logo.png',
  'allowLinkCopy': true,
  'showPoolBestDividend': true,
  'haveSeoData': true,
  'enableShare': false,
  'shareListEnabled': false,
  'shareRafEnabled': false,
  'shareRafTextVersions': 1,
  'defaultLanguage': 'en',
  'supportedLanguages': [
    'en'
  ],
  ignoreResultsCategories: ['NFL.FANTASY_OU',
    'NFL.FANTASY_MARGIN',
    'NBA.FANTASY_OU',
    'NBA.FANTASY_MARGIN',
    'ICE_HOCKEY.FANTASY_OU',
    'ICE_HOCKEY.FANTASY_MARGIN',
    'BASEBALL.FANTASY_OU',
    'BASEBALL.FANTASY_MARGIN',
    'FOOTBALL.FANTASY_OU',
    'FOOTBALL.FANTASY_MARGIN'],
  allowNewGroupCategoryCreation: false,
  'poolTypesOrder': {
    'FOOTBALL.MATCH': 10,
    'FOOTBALL.HDA': 20,
    'FOOTBALL.CORRECT_SCORE': 30,
    'FOOTBALL.OVER_UNDER': 40,
    'FOOTBALL.BTTS': 50,
    'FOOTBALL.ASIAN_HANDICAP': 60,
    'NFL.POINT_MARGIN': 70,
    'NBA.POINT_MARGIN': 80,
    'TENNIS.CORRECT_SCORE_3': 90,
    'TENNIS.CORRECT_SCORE_5': 100,
    'TENNIS.H2H': 110,
    'WRC.RACE_ORDER': 120,
    'WRC.RACE_WIN': 130,
    'HORSE_RACING.RACE_PLACE': 140,
    'HORSE_RACING.RACE_WIN': 150,
    'HORSE_RACING.RACE_ORDER': 160,
    'GREYHOUNDS.RACE_PLACE': 170,
    'GREYHOUNDS.RACE_WIN': 180,
    'GREYHOUNDS.RACE_ORDER': 190,
    'FANTASY_GAMES.FANTASY_OU': 200,
    'FANTASY_GAMES.FANTASY_MARGIN': 210,
    // newly auto-generated codes
    'NFL.FANTASY_OU': 220,
    'NFL.FANTASY_MARGIN': 230,
    'NBA.FANTASY_OU': 240,
    'NBA.FANTASY_MARGIN': 250,
    'ICE_HOCKEY.FANTASY_OU': 260,
    'ICE_HOCKEY.FANTASY_MARGIN': 270,
    'BASEBALL.FANTASY_OU': 280,
    'BASEBALL.FANTASY_MARGIN': 290,
    'FOOTBALL.FANTASY_OU': 300,
    'FOOTBALL.FANTASY_MARGIN': 310
  },
  'socialNetworks': { 'twitter': true, 'facebook': true, 'whatsapp': true },
  'shareSyndicateDynamicText': true,
  'numberOfSharingTextVersions': 10,
  'enableStats': true,
  'haveManagerRebates': false,
  'haveVoidToSolo': true,
  'haveTwitterWidgets': false,
  'widgetBanners': {
    SPORTS: [{ 'default': { image: '/assets/images/widget/colossus/placeholder.jpg', path: null, external: false } }],
    RACING: [{ 'default': { image: '/assets/images/widget/colossus/racing.jpg', path: null, external: false } }],
    HORSE_RACING: [{ 'default': { image: '/assets/images/widget/colossus/racing.jpg', path: null, external: false } }]
  },
  'blackListedPageviewPaths': ['landing'],
  'trackVirtualPageviews': true,
  'persistentLandingPage': true,
  'alwaysNewUser': false,
  'enableInternalTracking': false,
  'stickyBetslip': true,
  'bannerExpirationTimeout': 7,
  'shareWithTwitterHandler': true,
  'trackingUrl': 'https://tracking.colossusbets.com/',
  hideFreeplayTab: false,
  rootUrl: '/',
  haveGroupedTickets: false,
  avatarImageFolder: '/images/us-useravatars/',
  modalLaunchCustomSettings: {
    cordova: false,
    iframe: true
  },
  retryBetAfterGeolocation: true,
  provideSDKsupport: true,
  requireBetConfirmation: true
};
